import 'cropperjs/dist/cropper.css';
import PageStyle from '@/styles/components/job-live/_index.module.scss';
import ComponentStyle from '@/styles/components/cropper-filter/_index.module.scss';
import CloseWhite from 'public/icons/closewhite.svg';     
import Button from '@/components/button';

export function CustomCropper(props)
{

    return(
               <div className={`JobFilterModal CropperModal ${PageStyle.Modalpopup} profilepic`}>
                    <div className={ComponentStyle.CropImage}>

                            <div className={ `${ComponentStyle.CropImage__Head}` }>
                            <h3>Crop Image</h3>
                            <div className = {`${ComponentStyle.ModalClose}`} onClick={(event)=>{
                                                                                                    props.viewProfileAction.closeCropperModal();
                                                                                                }}>
                                <CloseWhite />
                            </div>
                            </div>

                            <div className={ComponentStyle.CropImage__Inner}>
                                <div className='CustomCropperContainer'>
                                    <img src = '/images/pages/profilepic/profilepic.png'  className="Cropper__Image"/>

                                    <div className='CustomCropper'>
                                        <div className="CustomCropper__Acion mt20">

                                            <div className={ComponentStyle.CropImage__Actions}>
                                               <h3>Zoom </h3>
                                                <Button onClick={()=>{props.viewProfileAction.zoom_in()}}> <span>+</span></Button>
                                                <Button onClick={()=>{props.viewProfileAction.zoom_out()}}> <span  style={{marginBottom: "3px"}} >-</span> </Button>
                                            </div>
                                            <Button buttonstyle={`m0 ${ComponentStyle.primarybtn}`} onClick={()=>{
                                                                                                                    props.viewProfileAction.getCroppedImage();
                                                                                                                    document.querySelector('.CropperModal').style.visibility = 'hidden'
                                                                                                                }}>Crop Image</Button>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                    </div>
                </div>
         )

}